import type { JSX } from 'react';
import type { SortState } from '@/shared/types/table-filters.types';
import { CandidateTable } from './CandidateTable';
import { CandidateCard } from './CandidateCard';
import type { Candidate, CandidateStatus } from '../types/candidate.types';

export interface CandidateListProps {
  candidates: Candidate[];
  isLoading: boolean;
  sort: SortState | null;
  onToggleSort: (key: string) => void;
  onEdit: (candidate: Candidate) => void;
  onDelete: (id: string) => void;
  onStatusChange: (id: string, status: CandidateStatus) => void;
  onResendInvitation: (id: string) => void;
  onCopyLink: (shareId: string) => void;
}

/** Desktop table and mobile cards render the same already filtered/sorted candidates. */
export function CandidateList({
  candidates,
  isLoading,
  sort,
  onToggleSort,
  ...itemHandlers
}: CandidateListProps): JSX.Element {
  if (isLoading) {
    return <div className="text-center py-8 text-muted-foreground">Loading candidates...</div>;
  }

  return (
    <>
      <div className="hidden md:block">
        <CandidateTable
          candidates={candidates}
          sort={sort}
          onToggleSort={onToggleSort}
          {...itemHandlers}
        />
      </div>

      <div className="grid gap-4 md:hidden">
        {candidates.map((candidate) => (
          <CandidateCard key={candidate.id} candidate={candidate} {...itemHandlers} />
        ))}
      </div>
    </>
  );
}
